module.exports = __webpack_public_path__ + "static/media/black-logo-second.01b4e37e.jpg";